<label class="form-switch">
    <span class="switch-text">Autoplay</span>
    <input type="checkbox" [(ngModel)]="autoplay" (change)="changed()">
    <i></i>
</label>